import _ from 'lodash';
import React from 'react';
import { buildGoogleMapsSearchUrl } from '../../../utility/map';
import AppLink from '../AppLink/AppLink';

interface IGeoLinkProps {
  address?: string;
}

export default function GeoLink({ address }: IGeoLinkProps) {
  if (_.isEmpty(address)) return null;

  return (
    <AppLink to={buildGoogleMapsSearchUrl(address!)} target="_blank">
      {address}
    </AppLink>
  );
}
